import Footer from "./Footer/Footer";
import AdditionalServices from "./Homepage/AdditionalServices";
import CTA from "./Homepage/CTA";
import CustomerStories from "./Homepage/CustomerStories";
import Hero from "./Homepage/Hero";
import OurStoryVideo from "./Homepage/OurStoryVideo";
import Reviews2 from "./Homepage/Reviews2";
import Navbar from "./NavBar/NavBar";
import { Helmet } from "../seo/Helmet";

function Homepage() {
  return (
    <>
    <Helmet>
      <title>Seattle Window Cleaning & Exterior Services | Lennon Window Cleaning</title>
      <meta
        name="description"
        content="Lennon Window Cleaning provides trusted window cleaning, pressure washing, gutter cleaning, roof cleaning, and solar panel cleaning for homes in Seattle and nearby communities."
      />
      <link rel="canonical" href="https://www.lennonwindowcleaning.com/" />
      <meta property="og:title" content="Seattle Window Cleaning & Exterior Services | Lennon Window Cleaning" />
      <meta
        property="og:description"
        content="Professional exterior cleaning services in Seattle, WA—from streak-free windows to gutters, roofs, pressure washing, and solar panel cleaning."
      />
      <meta property="og:url" content="https://www.lennonwindowcleaning.com/" />
      <meta property="og:image" content="https://www.lennonwindowcleaning.com/android-chrome-512x512.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Seattle Window Cleaning & Exterior Services | Lennon Window Cleaning" />
      <meta
        name="twitter:description"
        content="Professional exterior cleaning services in Seattle, WA—from streak-free windows to gutters, roofs, pressure washing, and solar panel cleaning."
      />
      <meta name="twitter:image" content="https://www.lennonwindowcleaning.com/android-chrome-512x512.png" />
    </Helmet>
    <Navbar />
    <Hero />
    <AdditionalServices />
    <CustomerStories />
    <OurStoryVideo />
    <Reviews2 />
    <CTA />
    <Footer />
    </>
  );
}

export default Homepage;
